<template>
  <div class="col-span-6">
    <label for="field.label" class="block text-sm font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input type="number" @change="$parent.updateValue(field.key, $event.target.value)" :value="this.value"  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="0.00" aria-describedby="price-currency">
      <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <span class="text-gray-500 sm:text-sm sm:leading-5" id="price-currency">
          {{field.unit}}
        </span>
      </div>
    </div>
    <p v-if="validation !== undefined" class="mt-2 text-sm text-red-600" id="email-error">* {{validation.msg}}</p>
  </div>
</template>

<script>
export default {
  name: 'number-field',
  data() {
    return {
      dependentdata: [],
      value: ""
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    validation: {
      type: Object,
      required: false
    }
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        console.log('formdata', newVal)
        if (this.field.depends !== '') {
          if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
            this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
            await this.fetchInitialValue()
          }
        }
      }
    },
  },
  methods: {
    checkDepends() {
      if (this.field.options.depends !== "") {
        this.fetchInitialValue()
      }
    },
    async fetchInitialValue() {
      console.log('fetchOptions')
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          key: this.field.options_key,
          ...this.params,
          ...this.formdata,
          ...this.dependentdata
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      this.value = response.data.value
    }
  }
}
</script>
